/* eslint-disable prettier/prettier */
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import {
  ICourseSession,
  IGetQrSessionsParams,
} from "src/app/attendanceRecord/interfaces/SessionsInterface";
import { calendarUtils } from "src/app/calendar/utils/convertDates.utils";
import {
  IDataWPagination,
  ResponseDataInterfaces,
} from "src/app/models/Interfaces/ResponseDataInterfaces";
import {
  IReporteAsistenciaSession,
  ISetGradeObj,
} from "src/app/reports/interfaces/reports.interfaces";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class SessionsService {
  sessionsBaseUrl = `${environment.apiUrlCap}/api/sessions`;
  sendAssitanceUrl = `${environment.apiUrlCap}/api/sendAssistance`;
  GET_AND_POST_REPORTE_ASSISTANCE_ENDPOINT = `${environment.apiUrlCap}/api/report/assistance`;

  constructor(private http: HttpClient) {}

  getAttendances(cornerStoneSesionId: number): Observable<any> {
    return this.http.get(
      `${this.sessionsBaseUrl}/assitances/${cornerStoneSesionId}`
    );
  }
  private mapSessionList(data: ICourseSession[]) {
    return data.map(item => ({
      ...item,
      fechaAlta: item.fechaAlta
        ? calendarUtils.convertToLocalDate(item.fechaAlta)
        : item.fechaAlta,
      fechaInicio: item.fechaInicio
        ? calendarUtils.convertToLocalDate(item.fechaInicio)
        : item.fechaInicio,
    }));
  }

  getCoursesSessionsByUserId(
    userId: number,
    searchParams?: IGetQrSessionsParams
  ): Observable<IDataWPagination<ICourseSession[]>> {
    const url = `${this.sessionsBaseUrl}/byUserId/${userId}`;

    let params = new HttpParams();
    for (const key in searchParams) {
      if (Object.hasOwn(searchParams, key)) {
        const value = searchParams[key as keyof IGetQrSessionsParams];
        if (value !== undefined && value !== null && value != "") {
          params = params.append(key, value.toString());
        }
      }
    }
    return this.http
      .get<ResponseDataInterfaces<ICourseSession[]>>(url, { params })
      .pipe(
        map(({ data, pagination }) => ({
          data: this.mapSessionList(data),
          pagination,
        }))
      );
  }
    getSharedCoursesSessionsByUserId(
    userId: number,
    searchParams?: IGetQrSessionsParams
  ): Observable<IDataWPagination<ICourseSession[]>> {
    const url = `${this.sessionsBaseUrl}/getSessionsShared/byUserId/${userId}`;

    let params = new HttpParams();
    for (const key in searchParams) {
      if (Object.hasOwn(searchParams, key)) {
        const value = searchParams[key as keyof IGetQrSessionsParams];
        if (value !== undefined && value !== null && value != "") {
          params = params.append(key, value.toString());
        }
      }
    }
    return this.http
      .get<ResponseDataInterfaces<ICourseSession[]>>(url, { params })
      .pipe(
        map(({ data, pagination }) => ({
          data: this.mapSessionList(data),
          pagination,
        }))
      );
  }
  // QRs global
  getAllUsersSessions(
  searchParams?: IGetQrSessionsParams
): Observable<IDataWPagination<ICourseSession[]>> {
  const url = `${environment.apiUrlCap}/api/sessions/getAllUsers`;

  let params = new HttpParams();

  for (const key in searchParams) {
    if (Object.hasOwn(searchParams, key)) {
      const value = searchParams[key as keyof IGetQrSessionsParams];

      if (value !== undefined && value !== null && value != "") {
        params = params.append(key, value.toString());
      }
    }
  }

  return this.http
    .get<ResponseDataInterfaces<ICourseSession[]>>(url, { params })
    .pipe(
      map(({ data, pagination }) => ({
        data: this.mapSessionList(data),
        pagination,
      }))
    );
}
  // Get QR Shared
  getQRShared(
    userId: number,
    searchParams?: IGetQrSessionsParams
  ): Observable<IDataWPagination<ICourseSession[]>> {
    const url = `${this.sessionsBaseUrl}/getQRShared/${userId}`;
    let params = new HttpParams();
    for (const key in searchParams) {
      if (Object.hasOwn(searchParams, key)) {
        const value = searchParams[key as keyof IGetQrSessionsParams];
        if (value !== undefined && value !== null && value != "") {
          params = params.append(key, value.toString());
        }
      }
    }
    return this.http
      .get<ResponseDataInterfaces<ICourseSession[]>>(url, { params })
      .pipe(
        map(({ data, pagination }) => ({
          data: this.mapSessionList(data),
          pagination,
        }))
      );
  }

  getSessionBySessionId(sessionId: any): Observable<ICourseSession> {
    return this.http
      .get<ResponseDataInterfaces<ICourseSession>>(
        `${this.sessionsBaseUrl}/${sessionId}`
      )
      .pipe(
        map(({ data }) => ({
          ...data,
          fechaAlta: data.fechaAlta
            ? calendarUtils.convertToLocalDate(data.fechaAlta)
            : data.fechaAlta,
          fechaInicio: data.fechaInicio
            ? calendarUtils.convertToLocalDate(data.fechaInicio)
            : data.fechaInicio,
        }))
      );
  }
  getReporteAsistenciaSession(
    sesionId: number,
    numberSesion?: number,
    page = 1,
    pageSize = 100,
    search?: string
  ): Observable<IReporteAsistenciaSession> {
    let requestUrl = this.GET_AND_POST_REPORTE_ASSISTANCE_ENDPOINT;
    if (!numberSesion) {
      requestUrl = `${requestUrl}/${sesionId}?page=${page}&pageSize=${pageSize}`;

      if (search) {
        requestUrl += `&search=${encodeURIComponent(search)}`;
      }

    } else {
      requestUrl = `${requestUrl}/${sesionId}/${numberSesion}?page=${page}&pageSize=${pageSize}`;

      if (search) {
        requestUrl += `&search=${encodeURIComponent(search)}`;
      }
    }
    return this.http
      .get<ResponseDataInterfaces<IReporteAsistenciaSession>>(requestUrl)
      .pipe(
        map(({ data }) => ({
          ...data,
          participantes: data.participantes.map(attendant => ({
            ...attendant,
            fechaRegistro: attendant.fechaRegistro,
          })),
        }))
      );
  }
  addQueueAssistances(localizatorId: number) {
    //service to complete assitances on GB University
    return this.http
      .get<ResponseDataInterfaces<boolean>>(
        `${this.sessionsBaseUrl}/addQueueAssistances/${localizatorId}`
      )
      .pipe(map(({ data }) => data));
  }

  registerAttendantsGrades(attendantsGrades: ISetGradeObj[]) {
    return this.http.post(
      `${this.sessionsBaseUrl}/setCalificationsByIdAssitance`,
      attendantsGrades
    );
  }
  AddQueueAssistance(localizatorId: number, userId: number) {
    return this.http.post(`${this.sendAssitanceUrl}/AddQueue`, {
      fkIdLocator: localizatorId,
      fkIdUsuario: userId,
    });
  }

  getCalendarSession(fkIdSesionCalendario: number) {
    return this.http
      .get<ResponseDataInterfaces<boolean>>(
        `${this.sessionsBaseUrl}/infoCalendarSessions/${fkIdSesionCalendario}`
      )
      .pipe(map(({ data }) => data));
  }
}
